export const ITEMS_PER_PAGE = 50;

export const SUMMARY_COLUMNS = [
  { key: 'contract_number', label: 'Nº Contrato' },
  { key: 'subscribers', label: 'Suscriptores' },
  { key: 'agreement_installments', label: 'Cuotas pactadas' },
  { key: 'paid_installments', label: 'Cuotas pagas' },
  { key: 'pending_installments', label: 'Cuotas pendientes' },
  { key: 'overdue_installments', label: 'Cuotas vencidas' },
  { key: 'total_paid', label: 'Total pagado' },
  { key: 'last_payment_date', label: 'Último pago' },
  { key: 'last_payment_amount', label: 'Monto último pago' },
  { key: 'overdue_amount', label: 'Mora' },
];

export const INSTALLMENT_COLUMNS = [
  { key: 'fee_number1', label: 'N° cuota' },
  { key: 'first_due_date', label: 'Vencimiento 1' },
  { key: 'second_due_date', label: 'Vencimiento 2' },
  { key: 'third_due_date', label: 'Vencimiento 3' },
  { key: 'payment_date', label: 'Fecha pago' },
  { key: 'payment_total', label: 'Monto pago' },
  { key: 'total_amount', label: 'Total cuota' },
];

export const OVERDUE_FILTER_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'true', label: 'Con mora' },
  { value: 'false', label: 'Sin mora' },
];
